module.exports = __webpack_public_path__ + "img/premium-features-header.f72ffa4e.png";